import React from 'react';
import clsx from 'clsx';
import { Passenger } from '../../../state/models';
import Icon from "react-icons-kit/Icon";
import { userCircleO } from "react-icons-kit/fa/userCircleO";
import { PriceBox } from './PriceBox';

import iconStyles from '../../../styles/icon.module.scss'
import { Ancillary, AnciPassengerKeys, AnciService } from '../../../state/models/Ancillary';

export type SelectedService = {
  passengerId: number;
  logicalFlightId: number;
  ssrCode: string;
}

type PassengerBoxProps = {
  passenger: Passenger;
  ancillaries: Ancillary[];
  currencyCode: string;
  onSelectService: (service: SelectedService) => void;
  onClearService: (service: SelectedService) => void;
  serviceKey: AnciPassengerKeys;
};

export function PassengerBox({passenger, ancillaries, currencyCode, onSelectService, onClearService, serviceKey}: PassengerBoxProps) {

  const services = findPassengerServices(passenger.id, serviceKey, ancillaries);
  if(!services.length) return null;

  const handleServiceClick = (service: AnciService, select: boolean) => {
    if(select) {
      if(typeof onClearService === 'function') {
        onClearService({
          passengerId: passenger.id,
          logicalFlightId: service.logicalFlightId,
          ssrCode: service.ssrCode,
        });
      }
      return
    }

    if(typeof onSelectService === 'function') {
      onSelectService({
        passengerId: passenger.id,
        logicalFlightId: service.logicalFlightId,
        ssrCode: service.ssrCode,
      });
    }
  }

  const paxName = passenger.firstName && passenger.lastName 
                  ? `${passenger.firstName} ${passenger.lastName}` 
                  : `${passenger.paxTypeName} Passenger ${passenger.paxIndex}`;

  return (
    <div className={clsx('tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between',
      'tw-border tw-border-solid tw-border-gray-200 tw-min-h-[125px]'
    )}>
      <div className='tw-p-6 md:tw-px-4 tw-flex tw-flex-row tw-items-center'>
        <Icon icon={userCircleO} className={iconStyles.user} />{paxName}
      </div>
      <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-justify-end'>
        {services.map((service, index) => {
          const selected = Array.isArray(passenger[serviceKey]) && passenger[serviceKey].some(x => x.logicalFlightId === service.logicalFlightId);
          return (<PriceBox key={index} 
            service={service} 
            selected={selected} 
            included={service.included} 
            purchased={service.purchased}
            currencyCode={currencyCode}  
            onClick={() => handleServiceClick(service, selected)}
          />)
        })}
      </div>
    </div>
  )
}


function findPassengerServices(passengerId: number, key: AnciPassengerKeys, ancillaries: Ancillary[]) {
  const result: AnciService[] = [];
  if(!Array.isArray(ancillaries)) return result;

  ancillaries.forEach(anci => {
    if(!Array.isArray(anci.passengers)) return;
    const passenger = anci.passengers.find(p => p.passengerId === passengerId);
    if(!passenger) return;
    if(!Array.isArray(passenger[key])) return;

    result.push(...passenger[key]);
  })

  return result;
}